import { Link, useLocation } from 'react-router-dom'
import { ChevronRight, Home } from 'lucide-react'

const segmentLabels: Record<string, string> = {
  dashboard: 'Dashboard',
  patients: 'Patients',
  search: 'Search',
  register: 'Register',
  demographics: 'Demographics',
  encounters: 'Encounters',
  census: 'Census',
  discharge: 'Discharge',
  orders: 'Orders',
  catalog: 'Catalog',
  sets: 'Order Sets',
  results: 'Results',
  pending: 'Pending',
  critical: 'Critical',
  medications: 'Medications',
  formulary: 'Formulary',
  reconciliation: 'Reconciliation',
  notes: 'Notes',
  worklist: 'Worklist',
  templates: 'Templates',
  'smart-phrases': 'Smart Phrases',
  appointments: 'Appointments',
  schedule: 'Schedule Management',
  waitlist: 'Waitlist',
  billing: 'Billing',
  charges: 'Charges',
  claims: 'Claims',
  payments: 'Payments',
  accounts: 'Accounts',
  statements: 'Statements',
  analytics: 'Analytics',
  reports: 'Reports',
  quality: 'Quality Measures',
  admin: 'Administration',
  users: 'Users',
  roles: 'Roles',
  facilities: 'Facilities',
  providers: 'Providers',
  integrations: 'Integrations',
  audit: 'Audit Log',
  system: 'System',
  licensing: 'Licensing',
  tiers: 'Tiers',
  pricing: 'Pricing',
  usage: 'Usage',
  allergies: 'Allergies',
  problems: 'Problems',
  immunizations: 'Immunizations',
  insurance: 'Insurance',
}

function formatSegment(segment: string): string {
  if (segmentLabels[segment]) return segmentLabels[segment]
  // If it looks like an ID (numeric or UUID-like), show it as-is
  if (/^\d+$/.test(segment) || /^[a-f0-9-]{8,}$/.test(segment)) return `#${segment}`
  // Capitalize and replace hyphens
  return segment
    .split('-')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ')
}

export default function Breadcrumb() {
  const location = useLocation()
  const segments = location.pathname.split('/').filter(Boolean)

  if (segments.length === 0) return null

  return (
    <nav aria-label="Breadcrumb" className="flex items-center gap-1.5 text-sm text-muted-foreground">
      <Link
        to="/dashboard"
        className="flex items-center gap-1 hover:text-foreground transition-colors"
      >
        <Home className="h-3.5 w-3.5" />
      </Link>
      {segments.map((segment, index) => {
        const path = '/' + segments.slice(0, index + 1).join('/')
        const isLast = index === segments.length - 1

        return (
          <span key={path} className="flex items-center gap-1.5">
            <ChevronRight className="h-3.5 w-3.5" />
            {isLast ? (
              <span className="font-medium text-foreground">
                {formatSegment(segment)}
              </span>
            ) : (
              <Link to={path} className="hover:text-foreground transition-colors">
                {formatSegment(segment)}
              </Link>
            )}
          </span>
        )
      })}
    </nav>
  )
}
